import { render, staticRenderFns } from "./ViolationMessageCenter.vue?vue&type=template&id=66e45f05&scoped=true"
import script from "./ViolationMessageCenter.vue?vue&type=script&lang=js"
export * from "./ViolationMessageCenter.vue?vue&type=script&lang=js"
import style0 from "./ViolationMessageCenter.vue?vue&type=style&index=0&id=66e45f05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e45f05",
  null
  
)

export default component.exports